/**
 * The venue types, in one place.
 *
 * Each public page, the feature pages and the dashboard all need the same
 * three facts about a type: the endpoint that lists it, the item_type the
 * features table keys on, and the path its pages live under. Keeping them
 * together stops a new type being added in five places and missed in a sixth.
 */

export const VENUE_TYPES = {
  hotel:      { itemType: 'hotel',      path: 'hotel',      listEndpoint: 'hotels/list' },
  restaurant: { itemType: 'restaurant', path: 'restaurant', listEndpoint: 'restaurants/list' },
  beach:      { itemType: 'beach',      path: 'beach',      listEndpoint: 'beaches/list' },
  explore:    { itemType: 'explore',    path: 'explore',    listEndpoint: 'explore/list' },
  play:       { itemType: 'play',       path: 'play',       listEndpoint: 'play/list' },
  wellness:   { itemType: 'wellness',   path: 'wellness',   listEndpoint: 'wellness/list' },
  shop_local: { itemType: 'shop_local', path: 'shop',       listEndpoint: 'shop-local/list' },
  service:    { itemType: 'service',    path: 'service',    listEndpoint: 'services/list' },
  experience: { itemType: 'experience', path: 'experience', listEndpoint: 'experiences/list' },
};

export const FEATURE_KINDS = ['review', 'interview', 'menu'];

/** Built from char codes so the escape cannot be folded into raw characters. */
const COMBINING_MARKS = new RegExp(
  '[' + String.fromCharCode(768) + '-' + String.fromCharCode(879) + ']',
  'g'
);

export const slugify = (str) => {
  try {
    return (str || '')
      .normalize('NFD')
      .replace(COMBINING_MARKS, '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  } catch {
    return '';
  }
};

export const parseList = (val) => {
  if (!val) return [];
  if (Array.isArray(val)) return val.map(v => String(v).trim()).filter(Boolean);
  return String(val).split(/\r?\n/).map(v => v.trim()).filter(Boolean);
};

export const hasText = (html) => !!(html && String(html).replace(/<[^>]*>/g, '').trim());
